import React, { useState } from "react";
import "./LandingPage.css";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import dashboardImg from "../Assets/myDashboard.png";
import assumptions from "../Assets/assumption.png";
import landedCost from "../Assets/landedCost.png";
import news from "../Assets/news.png";
import analytics from "../Assets/analytics.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import first from "../Assets/tarif matica.svg";
// import landedCost from '../Assets/landedCost.png'
import Header from "../Header/Header";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-cards";
import { Autoplay, EffectCards, EffectCreative } from "swiper/modules";
import axiosInstance from "../Utils/AxoisClient";
import tariffMatrix from "../Assets/tariff-matrix.png";

const sections = [
  {
    title: "Tariff Matrix",
    description:
      "Instantly compare tariffs across all origin & destination country combinations .",
    button: "Learn More",
    bgImage: `url(${tariffMatrix || ""})`,
    route: "/tariff-matrix",
    width: { xs: 12, sm: 6, md: 4, lg: 4 },
  },
  {
    title: "Landed Cost Benchmarking",
    description: "Get a comprehensive breakdown of total landed cost ",
    button: "Learn More",
    bgImage: `url(${landedCost || ""})`,
    route: "/detail-view",
    width: { xs: 12, sm: 6, md: 4, lg: 4 },
  },
  {
    title: "My Dashboard",
    description: "Access all your saved sourcing scenarios in your workspace ",
    button: "Learn More",
    bgImage: `url(${dashboardImg || ""})`,
    route: "/bookmark-data",
    width: { xs: 12, sm: 6, md: 4, lg: 4 }, // custom width
  },
  {
    title: "Assumption and Methodology",
    description:
      "View underlying assumptions behind different elements of the tool.",
    button: "Learn More",
    bgImage: `url(${assumptions || ""})`,
    route: "/assumption&methodology",
    width: { xs: 12, sm: 6, md: 4, lg: 4 }, // custom width
    //  { xs: 12, sm: 6, md: 4, lg: 4 }
  },

  {
    title: "News & Latest Developments",
    description: "Get latest updates on tariff, sea freight and logistics.",
    button: "Coming Soon",
    bgImage: `url(${news || ""})`,
    route: "",
    width: { xs: 12, sm: 6, md: 4, lg: 4 },
  },
  {
    title: "Analytics",
    description: "Analyze the true cost drivers behind your landed cost.",
    button: "Learn More",
    bgImage: `url(${analytics || ""})`,
    route: "/analytics",
    width: { xs: 12, sm: 6, md: 4, lg: 4 },
  },
];

const LandingPage = () => {
  const navigate = useNavigate();
  const [sliderImage, setSliderImage] = useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("company/slider-images");
        setSliderImage(response?.data?.data);
      } catch (error) {}
    };
    fetchData();
  }, []);
  

  return (
    <>
      <Header />
      <Box sx={{ marginTop: "67px" }}>
        <Box className="header_style">
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Welcome to Sourcing Compass,
          </Typography>
          <Typography>
            {/* Explore Our Site of powerful procurement tools to drive smarter
            sourcing and cost management */}
            Your Compass for Cost-Effective Global Sourcing
          </Typography>
        </Box>
        <div className="container-width">
          <Typography variant="body1" color="black" sx={{ margin: "30px 5px" }}>
            {/* Welcome to Tool Sourcing Compass, your go-to guide for finding the
            right tools for any project! We know that sourcing tools can be
            tough—whether you're a DIYer or a pro. That’s why we’ve created a
            platform that simplifies the process with a curated selection of
            high-quality tools. Our mission is to empower you with the knowledge
            to make informed decisions and have the best tools at your
            fingertips. Join us to discover the tools that will help you achieve
            your goals! */}
            Sourcing Compass is an end-to-end sourcing intelligence platform
            that provides full visibility into true landed costs across global
            supply chains. It delivers clear, actionable insights on tariff, sea
            freight, duties & taxes, port handling charges, and logistics,
            helping procurement teams optimize sourcing, reduce costs, and
            improve efficiency and resilience.
          </Typography>
        </div>
        <Box
          sx={{
            background:
              "linear-gradient(292deg, #E6E6FE 0.51%, #EED9F8 36.22%, #E5CCE2 64.27%, #FFF5F4 86.9%, #FFFAF4 98.74%)",
            p: 5,
          }}
        >
          <Grid container spacing={2}>
            {sections.map((sec, index) => (
              <Grid item {...sec.width} key={index}>
                <Box
                  sx={{
                    position: "relative",
                    height: 300,
                    borderRadius: 2,
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "transform 0.3s ease",
                    "&:hover": {
                      transform: "scale(1.02)",
                    },
                    backgroundImage: sec.bgImage,
                    backgroundSize: "cover", // <- key
                    backgroundPosition: "bottom",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <Box
                    sx={{
                      position: "relative",
                      // zIndex: 1,
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      color: "#fff",
                    }}
                  >
                    <Typography
                      variant="h5"
                      sx={{ p: 1, fontFamily: '"Lora", serif' }}
                    >
                      {sec.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        p: 1,
                      }}
                    >
                      {sec.description}
                    </Typography>
                    <Box sx={{ p: 1 }}>
                      <Button
                        variant="contained"
                        endIcon={<ArrowForwardIcon />}
                        // disabled={
                        //   sec.title === "Analytics" ||
                        //   sec.title === "News & Latest Developments"
                        // }
                        sx={{
                          background:
                            "linear-gradient(to right, #2c194d, #3a235c)",
                          color: "#fff",

                          borderRadius: "12px",
                          padding: "6px 16px",
                          textTransform: "none",
                          fontFamily: "'Lora', serif",
                          fontSize: "0.875rem",
                          boxShadow: "none",
                          "&:hover": {
                            background:
                              "linear-gradient(to right, #3a235c, #2c194d)",
                          },
                        }}
                        onClick={() => navigate(sec.route)}
                      >
                        {sec.button}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Grid
          container
          // spacing={2}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            height: { xs: "auto", md: "100vh" },
            pl: 8,
          }}
        >
          {/* Left Column - Text */}
          {/* <Box sx={{ flex: 1, pr: { xs: 0, md: 4 }, mb: { xs: 4, md: 0 } }}> */}
          <Grid item md={6} lg={6} xs={12}>
            <Typography
              variant="h4"
              fontWeight="bold"
              sx={{
                fontFamily: '"Lora", serif',
                color: "#4B2AAD",
                mb: 2,
                fontSize: { xs: "1.8rem", sm: "2rem", md: "2.4rem" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {/* Manage Your Team With Reports */}
            </Typography>
            
            <Box
              variant="body1"
              sx={{
                fontFamily: '"Lora", serif',
                color: "#333",
                lineHeight: 1.7,
                fontSize: { xs: "1rem", md: "1.125rem" },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              <ul>
                <li>
                  Landed Cost Comparison across major exporting countries for
                  each destination and material.
                </li>
                <li>
                  End-to-End Cost Traceability providing visibility of all cost
                  elements across the supply chain.
                </li>
                <li>
                  Trader view enhancements - Add and manage miscellaneous
                  charges with flexibility.
                </li>
                <li>
                  Negotiation Scenario Modelling with advanced benchmarking
                  across suppliers, routes, and Incoterms to make smarter,
                  data-driven decisions.
                </li>
              </ul>
            </Box>
          </Grid>

          {/* Right Column - Background Image */}
          <Grid
            item
            md={6}
            lg={6}
            xs={12}
            className="swiper-background"
            sx={{
              padding: 0,
              m: 0,
              display: "flex",
              // justifyContent: "flex-end",
              justifyContent: { xs: "center", md: "flex-end" }, // ✅ center on small
              alignItems: "center", // ✅ center vertically
            }}
          >
            <Swiper
              // effect={"cards"}
              grabCursor={true}
              // modules={[EffectCards, Autoplay]} // ✅ Add Autoplay here
              className="mySwiper"
              autoplay={{
                delay: 4500,
                disableOnInteraction: false,
              }}
              effect={"creative"}
              creativeEffect={{
                prev: {
                  shadow: true,
                  translate: [0, 0, -400],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              }}
              modules={[EffectCreative, Autoplay]}
              style={{ margin: 0, width: "100%" }}
              // className="mySwiper"
            >
              {sliderImage.length > 0 ? (
                sliderImage?.map((ele, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={`${process.env.REACT_APP_IMAGE_PATH}${ele?.image_path}`}
                      // src="http://localhost:4001/uploads/slider/images-1756117818356-329575823-Slice%202.svg"
                      alt="slide1"
                    />
                  </SwiperSlide>
                ))
              ) : (
                <>
                  {" "}
                  <SwiperSlide>
                    <img
                      // src={`${process.env.REACT_APP_IMAGE_PATH}${ele?.image_path}`}
                      src={first}
                      alt="slide1"
                    />
                  </SwiperSlide>
                </>
              )}
            </Swiper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default LandingPage;
